function Head() {
	return (
		<div className='page'>
			<div className='head'>Bards Gone Bad</div>
			<div className='desc'>a music blog</div>
		</div>
	);
}

export default Head;
